export default __webpack_public_path__ + "static/media/banner-03_644x450_crop_center.d6830f06.jpg";